function PartsTable({
  parts,
  selectedPart,
  hoveredPart,
  setSelectedPart,
  setHoveredPart,
  openSelector,
  selectedSkiLabel
}){

return(

<div style={styles.card}>

<div style={styles.headerRow}>

  <div style={styles.title}>Parts List</div>

  <button
  style={styles.updateButton}
  onClick={openSelector}
  onMouseEnter={(e)=>{
    e.currentTarget.style.transform="translateY(-1px)";
    e.currentTarget.style.boxShadow="0 8px 20px rgba(0,0,0,0.12)";
  }}
  onMouseLeave={(e)=>{
    e.currentTarget.style.transform="translateY(0)";
    e.currentTarget.style.boxShadow="0 4px 10px rgba(0,0,0,0.06)";
  }}
>
{selectedSkiLabel}
</button>
</div>

<div style={styles.tableHeader}>
<div>#</div>
<div>Part Name</div>
<div>OEM Part</div>
<div>Price</div>
<div>Stock</div>
</div>

{parts.map(part=>(
<div
key={part.id}
style={{
...styles.row,
background:
selectedPart===part.id
? "#f2f6ff"
: hoveredPart===part.id
? "#f7f9ff"
: "transparent"
}}
onClick={()=>setSelectedPart(part.id)}
onMouseEnter={()=>setHoveredPart(part.id)}
onMouseLeave={()=>setHoveredPart(null)}
>

<div style={styles.index}>{part.id}</div>
<div>{part.name}</div>
<div style={styles.oem}>{part.oem}</div>

<div style={styles.price}>
${part.price?.toFixed(2)}
</div>

<div>✓

</div>

</div>
))}

</div>

)

}

export default PartsTable;



const styles={


card:{
position:"relative",
top:38,
left:-110,
width:500,



background:"rgba(246,249,255,0.96)",   // very light blue tint

borderRadius:28,
padding:28,

border:"1px solid rgba(255, 255, 255, 1)",

boxShadow:
"0 0 0 2px rgba(255,255,255,0.6), \
0 30px 70px rgba(0,0,0,0.10), \
0 18px 45px rgba(37,99,235,0.16)",

transform:"translateY(-8px)"
},
title:{
fontSize:18,
fontWeight:600,
marginBottom:20
},

tableHeader:{
display:"grid",
gridTemplateColumns:"40px 1fr 140px 80px 60px",
fontSize:12,
color:"#8E8E93",
marginBottom:10
},

row:{
display:"grid",
gridTemplateColumns:"40px 1fr 140px 80px 60px",
alignItems:"center",
padding:"14px 0",
borderBottom:"1px solid rgba(0,0,0,0.05)",
fontSize:14,
cursor:"pointer"
},

headerRow:{
display:"flex",
justifyContent:"space-between",
alignItems:"center",
marginBottom:20
},

updateButton:{
position:"absolute",
top:22,
right:26,

padding:"8px 14px",
borderRadius:18,
border:"1px solid rgba(0,0,0,0.06)",
background:"#ffffff",
fontSize:12,
fontWeight:600,
color:"#1D1D1F",
cursor:"pointer",

boxShadow:
"0 4px 10px rgba(0,0,0,0.06), \
 inset 0 1px 0 rgba(255,255,255,0.8)",

transition:"all .18s ease"
},

price:{
fontWeight:600,
color:"#1D1D1F"
},

index:{
width:28,
height:28,
borderRadius:"50%",
background:"#F2F3F7",
display:"flex",
alignItems:"center",
justifyContent:"center",
fontWeight:600,
fontSize:13
},

oem:{
color:"#6e6e73"
}

};